import API from '@/Core.Service.Domain/ViewSupport/Portfolio/API';

const getPortfolioSites = async (context) => {
  try {
    const portfolioSites = await API.getPortfolioSites();
    context.commit('PORTFOLIO_SITES', portfolioSites);
  } catch (error) {
    // Intentionally resolve on failure: callers treat the empty list as the
    // failure state, and portfolioSitesLoaded stays false so a later call
    // retries.
    console.error('Failed to fetch portfolio sites', error);
  }
};

export default {
  getPortfolioSites,
};
